import { useInfiniteQuery } from '@tanstack/react-query';

import { accessorialsInfiniteQueryOptions } from '../data-provider';
import type { AccessorialsFilters } from '../models';

export const useAccessorials = (filters: AccessorialsFilters | undefined, customerKey: number) => {
  return useInfiniteQuery(accessorialsInfiniteQueryOptions(filters, { customerKey, enabled: Boolean(filters) }));
};
